import { render, staticRenderFns } from "./CityContent1.vue?vue&type=template&id=0215823f&scoped=true"
import script from "./CityContent1.vue?vue&type=script&lang=js"
export * from "./CityContent1.vue?vue&type=script&lang=js"
import style0 from "./CityContent1.vue?vue&type=style&index=0&id=0215823f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215823f",
  null
  
)

export default component.exports